module.exports = __webpack_public_path__ + "static/media/cover_page_t2.106f824c.png";